import { Component, Input } from '@angular/core';
import { QuestionBase } from '../question-base';

@Component({
  selector: 'lms-info-expiration-date',
  templateUrl: './info-expiration-date.component.html',
  styleUrls: ['./info-expiration-date.component.scss']
})
export class InfoExpirationDateComponent {
  @Input() value: { seatsAmount: number; expirationDate: string };

  constructor() {}
}
